// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1_Ycu","inner":"Form_inner__1tXtG","range":"Form_range__3g6PB","name":"Form_name__1XlEt","actions":"Form_actions__6deiF"};